// dependencies imports ⇒
import React from "react";

// assets and scss imports ⇒
import RefreshIcon from "@mui/icons-material/Refresh";
import "./consentListMainContainer.scss";
// project file imports(UI components) ⇒
import ConsentListTableHeader from "./ConsentListTableHeader";
import ConsentListTableCell from "./ConsentListTableCell";
import ConsentListTableFooter from "./ConsentListTableFooter";
// const file imports(helper methods, etc) ⇒

function ConsentListMainContainer(props) {
  // const declarations ⇒
  const {
    activePage,
    setActivePage,
    consentList,
    requestStatusOptions,
    grantedStatusOptions,
    createdStatusOptions,
    setRequestStatusOptions,
    setCreatedStatusOptions,
    setGrantedStatusOptions,
    totalRecordCount,
    setConsentRequestId,
    getAbhaConsentList,
    handleSelectPage,
  } = props;

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒
  const onRefreshConsentList = () => {
    getAbhaConsentList();
  };

  // create UI ⇒

  const ConsentListMainUi = () => {
    return (
      <div className="consent-list-main-container">
        <div className="clmc-title-refresh-btn-wraper">
          <div className="clmc-title-refresh-btn">
            <div className="clmc-heading">Consent List</div>
            <div>
              <RefreshIcon
                className="clmc-refresh-btn"
                onClick={onRefreshConsentList}
              />
            </div>
          </div>
          <div className="clmc-new-consent-btn-wrapper">
            <div
              className="clmc-new-consent-btn"
              onClick={() => handleSelectPage(2)}
            >
              <span>Request New Consent</span>
            </div>
          </div>
        </div>
        <div className="consent-list-view-container">
          <div className="consent-list-view-wrapper">
            <ConsentListTableHeader
              setActivePage={setActivePage}
              setRequestStatusOptions={setRequestStatusOptions}
              setCreatedStatusOptions={setCreatedStatusOptions}
              setGrantedStatusOptions={setGrantedStatusOptions}
              requestStatusOptions={requestStatusOptions}
              grantedStatusOptions={grantedStatusOptions}
              createdStatusOptions={createdStatusOptions}
            />
            <div className="consent-table-list-container">
              <ConsentListTableCell
                consentList={consentList}
                setConsentRequestId={setConsentRequestId}
                handleSelectPage={handleSelectPage}
              />
            </div>
          </div>
        </div>
        {+totalRecordCount > 0 && (
          <ConsentListTableFooter
            setActivePage={setActivePage}
            activePage={activePage}
            totalRecordCount={totalRecordCount}
          />
        )}
      </div>
    );
  };

  //

  return (
    <div className="consent-main-list-container">{ConsentListMainUi()}</div>
  );
}

export default ConsentListMainContainer;
